module.exports = __webpack_public_path__ + "img/hr-green-asterisk-07.143dacf5.png";